import { LOGIN_USER, LOGIN_SUCCESS, LOGOUT_USER, LOGOUT_USER_SUCCESS, API_ERROR, USER_PLAN_SUCCESS, LOGIN_SUCCESS_DATA } from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  userPlan: "FREE",
  loginSuccessData: undefined,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LOGIN_SUCCESS_DATA:
      state = {
        ...state,
        loginSuccessData: action.payload,
      };
      break;
    case USER_PLAN_SUCCESS:
      state = {
        ...state,
        userPlan: action.payload,
      };
      break;
    case LOGOUT_USER:
      state = { ...state, isUserLogout: false };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state, isUserLogout: true };
      break;
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        isUserLogout: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
